<script>
import {mapGetters} from 'vuex';

export default {
    name: "OFontsController",
    data() {
        return {
            fonts: []
        }
    },
    watch: {
        isAppLoaded (val) {
            if(val && this.fontsConfig?.fonts?.length) this.fontsMount();
        }
    },
    computed: {
        ...mapGetters([
            'isAppLoaded',
            'getMapConfigProp'
        ]),
        fontsConfig() {
            return this.getMapConfigProp('fonts');
        }
    },
    methods: {
        fontsMount() {
            // this.fontsConfig.fonts.forEach(font => {
            //     const fontUrl = font.files.reduce((acc, {url, type}) =>`${acc ? acc + ',' : ''} url(${url}) format("${type}")` , '')
            //     this.fonts.push(new FontFace(font.name, fontUrl, font?.style))
            // })
            // this.fonts.forEach(async font => {
            //     try {
            //         await font.load();
            //         document.fonts.add(font);
            //     } catch (error) {
            //         console.error('FONT LOAD ERROR', error);
            //     }
            // })
            this.fontsConfig.fonts.forEach(font => {
                const fontUrl = font.files.reduce((acc, {url, type}) =>`${acc ? acc + ',' : ''} url(${url}) format("${type}")` , '')
                const fontStyle = font.style ? Object.entries(font.style).reduce((acc, [key, value]) =>`${acc} font-${key}: ${value};` , '') : '';
                const newStyle = document.createElement('style');
                newStyle.appendChild(document.createTextNode(`
                    @font-face {
                        font-family: "${font.name}";
                        src: ${fontUrl};
                        ${fontStyle}
                    }
                `));

                document.head.appendChild(newStyle);
            })

            if(this.fontsConfig.fontRoles) {
                Object.entries(this.fontsConfig.fontRoles).forEach(([priority, fontName]) => {
                    const root = document.documentElement;
                    root.style.setProperty(`--${priority}-font-family`, fontName);
                })
            }
        }
    },
    render(){ return null }
}

/**
 * data font example, in json format
 */
const testConfig = {
    "fonts": {
        "fonts": [
            {
                "name": "Veles",
                "files": [
                    {
                        "url": "https://fs.mvgcloud.com/assets/59367794/15281526/33551599/75511588.json",
                        "file_id": "75511588",
                        "type": "webgl"
                    },
                    {
                        "url": "https://fs.mvgcloud.com/assets/59367794/15281526/33551599/57581716.otf",
                        "file_id": "57581716",
                        "type": "otf"
                    },
                    {
                        "url": "https://fs.mvgcloud.com/assets/59367794/15281526/33551599/98557411.eot",
                        "file_id": "98557411",
                        "type": "eot"
                    },
                    {
                        "url": "https://fs.mvgcloud.com/assets/59367794/15281526/33551599/58255979.woff2",
                        "file_id": "58255979",
                        "type": "woff2"
                    },
                    {
                        "url": "https://fs.mvgcloud.com/assets/59367794/15281526/33551599/88391236.woff",
                        "file_id": "88391236",
                        "type": "woff"
                    },
                    {
                        "url": "https://fs.mvgcloud.com/assets/59367794/15281526/33551599/81554791.ttf",
                        "file_id": "81554791",
                        "type": "ttf"
                    }
                ],
                "style": {
                    "style": "normal",
                    "weight": "400"
                },
                "auto_load": true
            },
            {
                "name": "Miratrix",
                "files": [
                    {
                        "url": "https://fs.mvgcloud.com/assets/59367794/14118997/61315428/75446572.otf",
                        "file_id": "75511588",
                        "type": "otf"
                    }
                ],
                "auto_load": true
            }
        ],
        "fontRoles": {
            "primary": "Veles",
            "secondary": "Miratrix"
        }
    }
}

const realCofig = {
    "fonts": {
        "fonts": [
            {
                "name": "Arial Regular",
                "files": [
                    {
                        "url": "https://fs.mvgcloud.com/assets/59367794/54624135/43681251/73248790.woff2",
                        "file_id": "73248790",
                        "type": "woff2"
                    },
                    {
                        "url": "https://fs.mvgcloud.com/assets/59367794/54624135/43681251/98364749.woff",
                        "file_id": "98364749",
                        "type": "woff"
                    },
                    {
                        "url": "https://fs.mvgcloud.com/assets/59367794/54624135/43681251/68669924.ttf",
                        "file_id": "68669924",
                        "type": "ttf"
                    },
                    {
                        "url": "https://fs.mvgcloud.com/assets/59367794/54624135/43681251/84844372.eot",
                        "file_id": "84844372",
                        "type": "eot"
                    }
                ],
                "style": {
                    "style": "normal",
                    "weight": "normal"
                },
                "auto_load": true
            },
            // http://fs.mvgcloud.com/assets/59367794/93368713.woff
            {
                "name": "Avenir Next Bold", 
                "files": [
                    {
                        "url": "https://fs.mvgcloud.com/assets/59367794/69564848/42994183/56497397.woff2",
                        "file_id": "56497397",
                        "type": "woff2"
                    },
                    {
                        "url": "https://fs.mvgcloud.com/assets/59367794/69564848/42994183/23692198.woff",
                        "file_id": "23692198",
                        "type": "woff"
                    }
                ],
                "auto_load": true
            },
            {
                "name": "Montserrat Regular",
                "files": [
                    {
                        "url": "https://fs.mvgcloud.com/assets/59367794/29425945/91331779/99961420.woff2",
                        "file_id": "99961420",
                        "type": "woff2"
                    },
                    {
                        "url": "https://fs.mvgcloud.com/assets/59367794/29425945/91331779/95755658.woff",
                        "file_id": "95755658",
                        "type": "woff"
                    }
                ],
                "auto_load": true
            },
            //http://fs.mvgcloud.com/assets/73291648/89892987/12581229.woff
            {
                "name": "Montserrat Bold",
                "files": [
                    {
                        "url": "https://fs.mvgcloud.com/assets/59367794/29425945/92198740/64367590.woff2",
                        "file_id": "64367590",
                        "type": "woff2"
                    },
                    {
                        "url": "https://fs.mvgcloud.com/assets/59367794/29425945/92198740/46718950.woff",
                        "file_id": "46718950",
                        "type": "woff"
                    }
                ],
                "auto_load": true
            },
            // Sohne-Dreiviertelfett.0575ac6d.woff2 +
            {
                "name": "Sohne",
                "style": {
                    "style": "normal",
                    "weight": 600
                },
                "files": [
                    {
                        "url": "https://fs.mvgcloud.com/assets/59367794/64659136/45588776/63719446.woff2",
                        "file_id": "63719446",
                        "type": "woff2"
                    },
                    {
                        "url": "https://fs.mvgcloud.com/assets/59367794/64659136/45588776/16229389.otf",
                        "file_id": "16229389",
                        "type": "otf"
                    }
                ],
                "auto_load": true
            },
            {
                "name": "Sohne Semi Bold",
                "files": [
                    {
                        "url": "https://fs.mvgcloud.com/assets/59367794/64659136/21413847/52221512.woff2",
                        "file_id": "52221512",
                        "type": "woff2"
                    },
                    {
                        "url": "https://fs.mvgcloud.com/assets/59367794/64659136/21413847/59475659.woff",
                        "file_id": "59475659",
                        "type": "woff"
                    }
                ],
                "auto_load": true
            },
            {
                "name": "Sohne Normal",
                "files": [
                    {
                        "url": "https://fs.mvgcloud.com/assets/59367794/64659136/93798734/14486359.woff2",
                        "file_id": "14486359",
                        "type": "woff2"
                    },
                    {
                        "url": "https://fs.mvgcloud.com/assets/59367794/64659136/93798734/78141423.woff",
                        "file_id": "78141423",
                        "type": "woff"
                    }
                ],
                "auto_load": true
            },
            {
                "name": "Sohne Extra Bold",
                "files": [
                    {
                        "url": "https://fs.mvgcloud.com/assets/59367794/64659136/48649946/23432637.woff2",
                        "file_id": "23432637",
                        "type": "woff2"
                    },
                    {
                        "url": "https://fs.mvgcloud.com/assets/59367794/64659136/48649946/66245520.woff",
                        "file_id": "66245520",
                        "type": "woff"
                    }
                ],
                "auto_load": true
            },
            {
                "name": "Sohne Medium",
                "files": [
                    {
                        "url": "https://fs.mvgcloud.com/assets/59367794/64659136/62775788/32743731.woff2",
                        "file_id": "32743731",
                        "type": "woff2"
                    },
                    {
                        "url": "https://fs.mvgcloud.com/assets/59367794/64659136/62775788/92491681.woff",
                        "file_id": "92491681",
                        "type": "woff"
                    }
                ],
                "auto_load": true
            },
            {
                "name": "Sohne Light",
                "files": [
                    {
                        "url": "https://fs.mvgcloud.com/assets/59367794/64659136/58239878/73641379.woff2",
                        "file_id": "73641379",
                        "type": "woff2"
                    },
                    {
                        "url": "https://fs.mvgcloud.com/assets/59367794/64659136/58239878/93692461.woff",
                        "file_id": "93692461",
                        "type": "woff"
                    }
                ],
                "auto_load": true
            },
            {
                "name": "Sohne Bold",
                "files": [
                    {
                        "url": "https://fs.mvgcloud.com/assets/59367794/64659136/49322415/35875642.woff2",
                        "file_id": "35875642",
                        "type": "woff2"
                    },
                    {
                        "url": "https://fs.mvgcloud.com/assets/59367794/64659136/49322415/31234223.woff",
                        "file_id": "31234223",
                        "type": "woff"
                    }
                ],
                "auto_load": true
            },
            {
                "name": "Veles",
                "files": [
                    {
                        "url": "https://fs.mvgcloud.com/assets/59367794/15281526/33551599/75511588.json",
                        "file_id": "75511588",
                        "type": "webgl"
                    },
                    {
                        "url": "https://fs.mvgcloud.com/assets/59367794/15281526/33551599/57581716.otf",
                        "file_id": "57581716",
                        "type": "otf"
                    },
                    {
                        "url": "https://fs.mvgcloud.com/assets/59367794/15281526/33551599/98557411.eot",
                        "file_id": "98557411",
                        "type": "eot"
                    },
                    {
                        "url": "https://fs.mvgcloud.com/assets/59367794/15281526/33551599/58255979.woff2",
                        "file_id": "58255979",
                        "type": "woff2"
                    },
                    {
                        "url": "https://fs.mvgcloud.com/assets/59367794/15281526/33551599/88391236.woff",
                        "file_id": "88391236",
                        "type": "woff"
                    },
                    {
                        "url": "https://fs.mvgcloud.com/assets/59367794/15281526/33551599/81554791.ttf",
                        "file_id": "81554791",
                        "type": "ttf"
                    }
                ],
                "style": {
                    "style": "normal",
                    "weight": "400"
                },
                "auto_load": true
            },
            {
                "name": "Miratrix",
                "files": [
                    {
                        "url": "https://fs.mvgcloud.com/assets/59367794/14118997/61315428/75446572.otf",
                        "file_id": "75511588",
                        "type": "otf"
                    }
                ],
                "auto_load": true
            },
        ]
    }
}

</script>
